import React from "react";
// import Lottie from "react-lottie";
// import animationData from './bunnyLoader.json'
import { IWrapperProps, IStyleProps } from "./interfaces";
import { Svg } from "./styles";
// const defaultOptions = {
//     loop: true,
//     autoplay: true,
//     animationData: animationData,
//     rendererSettings: {
//         preserveAspectRatio: 'xMidYMid slice'
//     }
// };

export const Loader = ({ margin = null }: IStyleProps) => (
    // <Lottie
    //     options={defaultOptions}
    //     height={80}
    //     width={80}
    //     isStopped={false}
    //     isPaused={false}
    // />
    <Svg margin={margin} width={60} height={60} viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg">
        <circle cx="15" cy="15" r="15">
            <animate
                attributeName="r"
                from="15"
                to="15"
                begin="0s"
                dur="0.8s"
                values="15;9;15"
                calcMode="linear"
                repeatCount="indefinite"
            />
            <animate
                attributeName="fillOpacity"
                from="1"
                to="1"
                begin="0s"
                dur="0.8s"
                values="1;.5;1"
                calcMode="linear"
                repeatCount="indefinite"
            />
        </circle>
        <circle cx="60" cy="15" r="9" attributeName="fillOpacity" from="1" to="0.3">
            <animate
                attributeName="r"
                from="9"
                to="9"
                begin="0s"
                dur="0.8s"
                values="9;15;9"
                calcMode="linear"
                repeatCount="indefinite"
            />
            <animate
                attributeName="fillOpacity"
                from="0.5"
                to="0.5"
                begin="0s"
                dur="0.8s"
                values=".5;1;.5"
                calcMode="linear"
                repeatCount="indefinite"
            />
        </circle>
        <circle cx="105" cy="15" r="15">
            <animate
                attributeName="r"
                from="15"
                to="15"
                begin="0s"
                dur="0.8s"
                values="15;9;15"
                calcMode="linear"
                repeatCount="indefinite"
            />
            <animate
                attributeName="fillOpacity"
                from="1"
                to="1"
                begin="0s"
                dur="0.8s"
                values="1;.5;1"
                calcMode="linear"
                repeatCount="indefinite"
            />
        </circle>
    </Svg>
);

export const LoaderWrapper = ({ children, style }: IWrapperProps) => (
    <>
    <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", ...style }}>{children}</div>
</>);

export default Loader;
